import React, { Component } from 'react';
import {
  Grid,
  Button,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Select,
  FormControl,
  MenuItem,
} from '@material-ui/core';
import '../../css/pricing/manageSubscription.scss';

class ManageSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <main>
          <header>
            <Grid container>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <h1>
                  Vivek Gupta
                  {' '}
                  <Button className="button">Free Trial</Button>
                </h1>
                <h2>Insurer</h2>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12} className="rightAlign">
                <h3>
                  <i className="material-icons">warning</i>
                </h3>
                <h4>14 Days Remaining</h4>
              </Grid>
            </Grid>
          </header>
          <section>
            <Grid container>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <article className="article__01">
                  <h1>
                    Benifits
                    <span> (as per your current plan)</span>
                  </h1>
                  <h2>
                    <i className="material-icons">check_circle</i>
                    <p>
                      At vero eos et accusamus et iusto odio dignissimos ducimus
                      qui blanditiis praesentium voluptatum deleniti atque
                      corrupti
                    </p>
                  </h2>
                  <h2>
                    <i className="material-icons">check_circle</i>
                    <p>
                      At vero eos et accusamus et iusto odio dignissimos
                      ducimusLorem ipsum dolar sit amet
                    </p>
                  </h2>
                  <h2>
                    <i className="material-icons">check_circle</i>
                    <p>At vero eos et accusamus et iusto odio</p>
                  </h2>
                  <h2>
                    <i className="material-icons">check_circle</i>
                    <p>
                      At vero eos et accusamus et iusto odio dignissimos ducimus
                      qui blanditiis praesentium voluptatum deleniti atque
                      corrupti
                    </p>
                  </h2>
                  <h2>
                    <i className="material-icons">check_circle</i>
                    <p>
                      At vero eos et accusamus et iusto odio dignissimos ducimus
                    </p>
                  </h2>
                </article>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <article className="article__02">
                  <h1>Customize Subscription</h1>
                  <h2>Current Subscription</h2>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell />
                        <TableCell>Plan</TableCell>
                        <TableCell>District</TableCell>
                        <TableCell>Pricing</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow className="selectController">
                        <TableCell>1-</TableCell>
                        <TableCell>
                          <FormControl className="formControl inputHead coloredForms inputFullWidth">
                            <Select
                              disableUnderline
                              name="dashboard-user"
                              className="selectEmpty modalDropdown"
                              inputProps={{ 'aria-label': 'user' }}
                              // value={satellitesSource}
                              displayEmpty
                              // onChange={ev => this._handleSatelliteSource(ev)}
                            >
                              <MenuItem>Stratigic Report</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <FormControl className="formControl inputHead coloredForms inputFullWidth">
                            <Select
                              disableUnderline
                              name="dashboard-user"
                              className="selectEmpty modalDropdown"
                              inputProps={{ 'aria-label': 'user' }}
                              // value={satellitesSource}
                              displayEmpty
                              // onChange={ev => this._handleSatelliteSource(ev)}
                            >
                              <MenuItem>Jaipur</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <span>10$</span>
                        </TableCell>
                      </TableRow>
                      <TableRow className="selectController">
                        <TableCell>2-</TableCell>
                        <TableCell>
                          <FormControl className="formControl inputHead coloredForms inputFullWidth">
                            <Select
                              disableUnderline
                              name="dashboard-user"
                              className="selectEmpty modalDropdown"
                              inputProps={{ 'aria-label': 'user' }}
                              // value={satellitesSource}
                              displayEmpty
                              // onChange={ev => this._handleSatelliteSource(ev)}
                            >
                              <MenuItem>Monitoring Report</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <FormControl className="formControl inputHead coloredForms inputFullWidth">
                            <Select
                              disableUnderline
                              name="dashboard-user"
                              className="selectEmpty modalDropdown"
                              inputProps={{ 'aria-label': 'user' }}
                              // value={satellitesSource}
                              displayEmpty
                              // onChange={ev => this._handleSatelliteSource(ev)}
                            >
                              <MenuItem>Jaipur</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <span>15$</span>
                        </TableCell>
                      </TableRow>
                      <TableRow className="selectController">
                        <TableCell>3-</TableCell>
                        <TableCell>
                          <FormControl className="formControl inputHead coloredForms inputFullWidth">
                            <Select
                              disableUnderline
                              name="dashboard-user"
                              className="selectEmpty modalDropdown"
                              inputProps={{ 'aria-label': 'user' }}
                              // value={satellitesSource}
                              displayEmpty
                              // onChange={ev => this._handleSatelliteSource(ev)}
                            >
                              <MenuItem>Select</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <FormControl className="formControl inputHead coloredForms inputFullWidth">
                            <Select
                              disableUnderline
                              name="dashboard-user"
                              className="selectEmpty modalDropdown"
                              inputProps={{ 'aria-label': 'user' }}
                              // value={satellitesSource}
                              displayEmpty
                              // onChange={ev => this._handleSatelliteSource(ev)}
                            >
                              <MenuItem>Select</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          <span>0$</span>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <h3>
                    <i className="material-icons">add_circle_outline</i>
                    {' '}
Add
                    More
                  </h3>
                  <h4>
                    Total:
                    <strong>25$</strong>
                  </h4>
                  <footer>
                    <Button>Continue</Button>
                  </footer>
                  {/*                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Plan</TableCell>
                        <TableCell>District</TableCell>
                        <TableCell>Pricing</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow className="selectController">
                        <TableCell>1-</TableCell>
                        <TableCell>Stratigic Report</TableCell>
                        <TableCell>Jaipur</TableCell>
                        <TableCell><span>10$</span></TableCell>
                      </TableRow>
                      <TableRow className="selectController">
                        <TableCell>2-</TableCell>
                        <TableCell>Monitoring Report</TableCell>
                        <TableCell>Jaipur</TableCell>
                        <TableCell><span>15$</span></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <h4>Total:<strong>25$</strong></h4>
                  <footer>
                    <Button>Change Subscription</Button>
                  </footer> */}
                </article>
              </Grid>
            </Grid>
          </section>
        </main>
      </React.Fragment>
    );
  }
}

export default ManageSubscription;
